var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-list-field',{attrs:{"align":"center","demoted-icon":_vm.field.type,"is-sticky":_vm.isSticky,"is-demoted":_vm.isDemoted,"field":_vm.field,"filter":_vm.filter}},[(_vm.item.play.length)?_c('span',[_vm._v(_vm._s(_vm.item.play.length))]):_vm._e(),(!_vm.item.play.length)?_c('span',[_vm._v("-")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }